export class HttpException extends Error {
  code?: number;
  info?: string;
}
